import { keyBy, some, map, range, first, last, chunk, mapValues, inRange, filter } from "lodash";
import * as moment from "moment";
import * as DateTypes from "../DataTypes/dateTypes";
import * as StoreTypes from "../DataTypes/storeTypes";

export function getAvailability(date: moment.Moment, data: DateTypes.Availability) {
    const year = date.year();
    const month = date.format("MM");

    const yearData = data[year];
    if (!yearData) {
        return null;
    }

    const availability = yearData[month];

    if (!availability) {
        return null;
    }

    const availabilityByDate = keyBy(availability, "date");

    const weeks = processMonth(date, availabilityByDate);

    return weeks;
}

function processMonth(month: moment.Moment, availabilityByDate): DateTypes.IDay[][] {
    if (some(availabilityByDate, "availableTimes")) {
        const days = getMonthDates(month);

        map(days, function (day: DateTypes.IDay) {
            day.availability = getAvailabilityRange(availabilityByDate[day.date.format("YYYY-MM-DD")]);

            processDay(day, availabilityByDate);
        });

        return getMonthWeeks(days);
    } else {
        return [];
    }
}

function processDay(day: DateTypes.IDay, availabilityByDate) {
    day.availability = processAvailability(availabilityByDate[day.date.format("YYYY-MM-DD")], day.availability);
}

function getMonthDates(month: moment.Moment): DateTypes.IDay[] {
    return map(range(month.daysInMonth()), function (day) {
        return {
            date: moment(month).date(day + 1),
        };
    });
}

function getMonthWeeks(dates: DateTypes.IDay[]): DateTypes.IDay[][] {
    var firstDayOfMonth = first(dates).date;
    var lastDayOfMonth = last(dates).date;

    var beforeDays = firstDayOfMonth.day() == 0 ? 6 : firstDayOfMonth.day() - 1;
    var afterDays = lastDayOfMonth.day() == 0 ? 0 : 7 - lastDayOfMonth.day();

    // we want exactly 7 elements for each week
    range(beforeDays).forEach(function () {
        dates.unshift({ date: null, availability: null });
    });
    range(afterDays).forEach(function () {
        dates.push({ date: null, availability: null });
    });

    return chunk(dates, 7);
}

function availabilityRangeLimits() {
    return {
        morning: [0, 12],
        afternoon: [12, 18],
        evening: [18, 24],
    };
}

function getAvailabilityRange(day: DateTypes.IPowerTimeDay): DateTypes.IDayPeriod {
    if (!day) {
        return null;
    }

    return mapValues(availabilityRangeLimits(), function (limits) {
        return some(day.availableTimes, function (value: DateTypes.ISlot, index) {
            const hour = parseInt(value.hour);
            return inRange(hour, limits[0], limits[1]);
        });
    });
}

function processAvailability(availability, range) {
    if (!availability) {
        return null;
    }

    var availableTimes = map(availability.availableTimes, function (slot) {
        slot.date = moment.utc(availability.date + " " + slot.hour, "YYYY-MM-DD HH:mm");
        //slot.format = format(slot);
        return slot;
    });

    return mapValues(availabilityRangeLimits(), function (limits, index) {
        return range[index] ? checkAvailabilityRange(limits, availableTimes) : false;
    });
}

function checkAvailabilityRange(limits, values) {
    return filter(values, function (value) {
        return limits[0] <= value.date.hour() && value.date.hour() < limits[1];
    });
}

export function getShowingDateByInfo(info: StoreTypes.IAvailabilityStepInfo): moment.Moment {
    let date = info.start;

    if (info.selectedDate) {
        date = info.selectedDate;
    } else if (info.navigationDate) {
        date = info.navigationDate;
    }

    return date.clone();
}

export function getShowingDate(
    start: moment.Moment,
    selectedDate: moment.Moment,
    navigationDate: moment.Moment
): moment.Moment {
    return getShowingDateByInfo({ start, selectedDate, navigationDate, id: 0, summary: null });
}

export function getAppointmentDateTimeLabel(date: moment.Moment) {
    // format example: Thu 22nd 2021 June At 11:00 AM
    return date.format("ddd Do MMMM YYYY [at] hh:mm A");
}

export function getAppointmentDateTimeLabelWithThreeLetterMonth(date: moment.Moment) {
    // format example: Thu 22nd 2021 Feb at 11:00 AM
    return date.format("ddd Do YYYY MMM [at] hh:mm A");
}
